export const institutions = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
<g>
   <polygon points="256,7.396 85.012,75.943 426.987,75.943 		"/>
</g>
</g>
<g>
<g>
   <rect x="17.342" y="393.046" width="477.316" height="40.566"/>
</g>
</g>
<g>
<g>
   <rect y="464.038" width="512" height="40.566"/>
</g>
</g>
<g>
<g>
   <rect x="271.218" y="195.143" width="78.648" height="167.489"/>
</g>
</g>
<g>
<g>
   <rect x="380.281" y="195.143" width="78.648" height="167.489"/>
</g>
</g>
<g>
<g>
   <rect x="162.144" y="195.143" width="78.648" height="167.489"/>
</g>
</g>
<g>
<g>
   <rect x="53.071" y="195.143" width="78.648" height="167.489"/>
</g>
</g>
<g>
<g>
   <rect x="17.342" y="106.373" width="477.316" height="58.365"/>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`;